<template>
  <b-modal
    id="page-amilia-modal"
    :ok-title="trans(block && block.id ? 'save' : 'create')"
    :cancel-title="trans('cancel')"
    size="xl"
    no-enforce-focus
    @shown="onShown"
    @ok="onSave"
  >
    <template v-slot:modal-title>
      <span>{{ label }}</span>
      <small v-if="!!block" class="text-muted ml-2">
        #{{ block.id }}
      </small>
    </template>

    <b-row>
      <b-col class="col-12 col-lg-8">
        <b-tabs v-model="tab" content-class="mt-3">
          <b-tab title="Amilia">
            <b-form-group v-if="type == 'amilia-program' || type == 'amilia-activity'" :label="trans('program')" class="mb-3">
              <b-form-select
                v-model="amilia_program_id"
                v-on:change="onProgramChange()"
                :options="programOptions"
                :disabled="busy"
              ></b-form-select>
            </b-form-group>
            
            <b-form-group v-if="type == 'amilia-activity'" :label="trans('activity')" class="mb-3">
              <treeselect
                id="treeselect"
                :multiple="false"
                openDirection="below"
                :options="activityOptions"
                :default-expand-level="2"
                :disable-branch-nodes="true"
                :placeholder="treeTitle"
                :disabled="busy"
                v-model="amilia_activity_id"
              >
              </treeselect>
            </b-form-group>

            <b-form-group v-if="type == 'amilia-membership'" :label="trans('membership')" class="mb-3">
              <b-form-select
                v-model="amilia_membership_id"
                :options="membershipOptions"
                :disabled="busy"
              ></b-form-select>
            </b-form-group>
            
            <b-form-group :label="trans('width')">
              <b-form-radio-group v-model="image_percent" :options="image_percent_options" />
            </b-form-group>
            
            <b-form-group :label="trans('position')">
              <b-form-radio-group v-model="span_row">
                <b-form-radio :value="false">
                  {{ trans('inline') }}
                </b-form-radio>
                <b-form-radio :value="true">
                  {{ trans('span_row') }}
                </b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <b-form-group v-if="span_row" :label="trans('align')">
              <b-form-radio-group v-model="h_align" :options="hAlignOptions"></b-form-radio-group>
            </b-form-group>
          </b-tab>
          <b-tab :title="trans('text')">
            <b-form-group>
              <html-textarea
                :organization="organization"
                v-model="text"
                for-microsite
                show-insert-form-document
                :placeholders="placeholders"
              ></html-textarea>
            </b-form-group>
          </b-tab>
        </b-tabs>
      </b-col>
      <b-col class="col-6 col-lg-4">
        <page-amilia-program-block
          v-if="showPreview && type == 'amilia-program'"
          :block="serializedForPreview"
        ></page-amilia-program-block>
        <page-amilia-membership-block
          v-if="showPreview && type == 'amilia-membership'"
          :block="serializedForPreview"
        ></page-amilia-membership-block>
        <page-amilia-activity-block
          v-if="showPreview && type == 'amilia-activity'"
          :block="serializedForPreview"
        ></page-amilia-activity-block>
      </b-col>
    </b-row>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect'
  import PageAmiliaProgramBlock from './PageAmiliaProgramBlock'
  import PageAmiliaMembershipBlock from './PageAmiliaMembershipBlock'
  import PageAmiliaActivityBlock from './PageAmiliaActivityBlock'
  import HtmlTextarea from './../../../common/components/HtmlTextarea'

  const activityPlaceholders = window.lang == 'fr' ?
    ['Activité', 'Sous-catégorie', 'Catégorie', 'Programmation', 'Places disponibles', 'Horaire', 'Date/heure de début', 'Date de début', 'Heure de début', 'Date/heure du prochain', 'Date du prochain', 'Heure du prochain', 'Date/heure de fin', 'Date de fin', 'Heure de fin', 'Les dates'] :
    ['Activity', 'Subcategory', 'Category', 'Program', 'Spots left', 'Schedule', 'Start date/time', 'Start date', 'Start time', 'Next date/time', 'Next date', 'Next time', 'End date/time', 'End date', 'End time', 'All dates']
  const activityText = `
      <h5 style="text-align:center;">
        <span class="placeholder">{${lang == 'fr' ? 'Activité' : 'Activity'}}</span>
      </h5>
      <p>
        <span class="placeholder">{${lang == 'fr' ? 'Programmation' : 'Program'}}</span>,
        <span class="placeholder">{${lang == 'fr' ? 'Catégorie' : 'Category'}}</span>,
        <span class="placeholder">{${lang == 'fr' ? 'Sous-catégorie' : 'Subcategory'}}</span>
      </p>
      <p>
        <span class="placeholder">{${lang == 'fr' ? 'Horaire' : 'Schedule'}}</span>
      </p>
      <p>
        ${trans('start')}:
        <span class="placeholder">{${lang == 'fr' ? 'Date/heure de début' : 'Start date/time'}}</span>
      </p>
      <p v-if="activity.spots_remaining != null">
        ${trans('remaining_spots')}:
        <span class="placeholder">{${lang == 'fr' ? 'Places disponibles' : 'Spots left'}}</span>
      </p>
  `

  const programPlaceholders = window.lang == 'fr' ?
    ['Programmation', 'Date de début', 'Date/heure de fin'] :
    ['Program', 'Start date', 'End date']
  const programText = `
    <h5 style="text-align:center;">
      <span class="placeholder">{${lang == 'fr' ? 'Programmation' : 'Program'}}</span>
    </h5>
  `

  const membershipPlaceholders = window.lang == 'fr' ?
    ['Abonnement'] :
    ['Membership']
  const membershipText = `
    <h5 style="text-align:center;">
      <span class="placeholder">{${lang == 'fr' ? 'Abonnement' : 'Membership'}}</span>
    </h5>
  `

  export default {
    props: {
      organization: Object,
      page: Object,
      block: Object,
      after: Number,
      type: {
        type: String,
        default: 'amilia-program', // amilia-activity, amilia-membership
      },
    },
    components: {
      Treeselect,
      PageAmiliaProgramBlock,
      PageAmiliaMembershipBlock,
      PageAmiliaActivityBlock,
      HtmlTextarea,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        tab: 0,
        meta: null,
        text: null,
        image_percent: 0.3333,
        image_percent_options: [
          {text: '25%', value: 0.25},
          {text: '33%', value: 0.3333},
          {text: '50%', value: 0.5},
          {text: '66%', value: 0.6666},
          {text: '75%', value: 0.75},
        ],
        span_row: false,
        h_align: 'center',
        hAlignOptions: [
          {value: 'left', text: trans('left')},
          {value: 'center', text: trans('center')},
          {value: 'right', text: trans('right')},
        ],
        amilia_program_id: null,
        amilia_activity_id: null,
        amilia_membership_id: null,
        programs: null,
        programOptions: [{value: null, text: trans('select_a_program')}],
        activities: null,
        activityOptions: [],
        memberships: null,
        membershipOptions: [],
      }
    },
    computed: {
      label() {
        return this.type ? trans(this.type.replace('-', '_')) : 'Amilia'
      },
      treeTitle() {
        return !this.busy ? trans('select_activities') : trans('please_wait')
      },
      program() {
        if (!this.amilia_program_id || !this.programs) return null
        return _.find(this.programs, {id: this.amilia_program_id}) || null
      },
      activity() {
        if (!this.amilia_activity_id || !this.activities) return null
        return _.find(this.activities, {id: this.amilia_activity_id}) || null
      },
      membership() {
        if (!this.amilia_membership_id || !this.memberships) return null
        return _.find(this.memberships, {id: this.amilia_membership_id}) || null
      },
      defaultText() {
        if (this.type == 'amilia-program') return programText
        if (this.type == 'amilia-activity') return activityText
        if (this.type == 'amilia-membership') return membershipText
        return null
      },
      placeholders() {
        if (this.type == 'amilia-program') return programPlaceholders
        if (this.type == 'amilia-activity') return activityPlaceholders
        if (this.type == 'amilia-membership') return membershipPlaceholders
        return null
      },
      serialized() {
        return {
          type: this.type,
          text: this.text,
          image_percent: this.image_percent,
          span_row: this.span_row,
          h_align: this.h_align,
          meta: this.meta,
          amilia_program_id: this.amilia_program_id,
          amilia_activity_id: this.amilia_activity_id,
          amilia_membership_id: this.amilia_membership_id,
          after: this.after,
        }
      },
      serializedForPreview() {
        return _.assign({}, this.serialized, {span_row: false})
      },
      showPreview() {
        return this.type == 'amilia-program' && !!this.program ||
          this.type == 'amilia-activity' && !!this.activity ||
          this.type == 'amilia-membership' && !!this.membership
      },
    },
    watch: {
      activity() {
        if (this.type == 'amilia-activity') this.meta = this.activity
      },
      program() {
        if (this.type == 'amilia-program') this.meta = this.program
      },
      membership() {
        if (this.type == 'amilia-membership') this.meta = this.membership
      },
    },
    methods: {
      onShown() {
        this.busy = false
        this.error = null
        this.tab = 0
        this.text = this.block ? this.block.text || this.defaultText : this.defaultText
        this.image_percent = this.block ? this.block.image_percent || 0.3333 : 0.3333
        this.span_row = this.block ? this.block.span_row || false : false
        this.h_align = this.block ? this.block.h_align || 'center' : 'center'
        this.meta = this.block ? this.block.meta : null
        this.amilia_program_id = this.block ? this.block.amilia_program_id : null
        this.amilia_activity_id = this.block ? this.block.amilia_activity_id : null
        this.amilia_membership_id = this.block ? this.block.amilia_membership_id : null
        this.activityOptions = this.amilia_activity_id ? [{id: this.amilia_activity_id, label: '...'}] : []
        if (this.type != 'amilia-membership' &&
          this.programs == null)
          this.loadPrograms()
        if (this.type == 'amilia-membership' &&
          this.memberships == null)
          this.loadMemberships()
        this.$nextTick(() => {
          if (this.type == 'amilia-activity' &&
            this.programs != null &&
            this.amilia_activity_id &&
            !this.activity)
            this.loadActivities()
        })
      },
      onSave(e) {
        e.preventDefault()
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/page/${this.page.id}/block`
        if (this.block && this.block.id) url += `/${this.block.id}`
        axios[this.block && this.block.id ? 'patch' : 'post'](url, this.serialized)
        .then(response => {
          this.busy = false
          this.$emit('saved', response.data)
          this.$bvModal.hide('page-amilia-modal')
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      loadPrograms() {
        this.busy = true
        this.error = null
        this.programs = null
        let url = `/organization/${this.organization.id}/amilia/programs?hide_archived=true&show_more=true`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.programs = response.data
          // Build the programs
          let hidden = []
          response.data.forEach(item => {
            let option = {
              value: item.id,
              text: item.name
            }
            if (item.visible)
              this.programOptions.push(option)
            else
              hidden.push(option)
          })
          if (hidden.length > 0) {
            this.programOptions.push({
              value: null,
              text: trans('visible_only_administrators'),
              disabled: true
            })
            hidden.forEach(option => {
              this.programOptions.push(option)
            })
          }
          if (this.type == 'amilia-activity' && this.amilia_program_id) this.loadActivities()
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onProgramChange() {
        this.amilia_activity_id = null
        if (this.type == 'amilia-activity' && this.amilia_program_id) this.loadActivities()
      },
      loadActivities() {
        this.busy = true
        this.error = null
        this.treeSelection = null
        this.activities = null
        let url = `/organization/${this.organization.id}/amilia/programs/${this.amilia_program_id}/activities?show_more=true`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.activities = response.data
          // Build the treeview
          let tree = {}
          this.activities.forEach(function(a) {
            if (!tree[a.category_id])
              tree[a.category_id] = {
                id: 'c' + a.category_id,
                label: a.category_name,
                isDefaultExpanded: true,
                children: {}
              }
            if (!tree[a.category_id].children[a.subcategory_id])
              tree[a.category_id].children[a.subcategory_id] = {
                id: 's' + a.subcategory_id,
                label: a.subcategory_name,
                children: []
              }
            let name = a.name
            if (a.is_hidden) name += ` (${trans('hidden').toLowerCase()})`
            if (a.is_cancelled) name += ` (${trans('cancelled').toLowerCase()})`
            tree[a.category_id].children[a.subcategory_id].children.push({
              id: a.id,
              label: name,
              isDisabled: a.disabled,
            })
          })
          tree = _.values(tree)
          tree.forEach(function(node) {
            node.children = _.values(node.children)
          })
          this.activityOptions = tree
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      loadMemberships() {
        let url = '/organization/' + this.organization.id + '/amilia/memberships?show_more=true'
        this.busy = true
        this.error = null
        this.membershipOptions = []
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.memberships = response.data
          let hidden = []
          response.data.forEach(item => {
            let option = {
              value: item.id,
              text: `${item.name} (${trans('amilia_membership_' + item.type).toLowerCase()})`
            }
            if (item.visible)
              this.membershipOptions.push(option)
            else
              hidden.push(option)
          })
          if (hidden.length > 0) {
            this.membershipOptions.push({
              value: null,
              text: trans('visible_only_administrators'),
              disabled: true
            })
            hidden.forEach(option => {
              this.membershipOptions.push(option)
            })
          }
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.pageAmiliaModal = this
    },
  }
</script>